<template>
	<div class="select-popup-view">
		<div class="options">
			<div class="option" v-for="(option, i) in options" :key="i" @click.stop="(() => { if (option.callback) option.callback(); })()">
				<div v-if="option.value" class="double">
					<div class="label">{{ option.label }}</div>
					<div class="value">{{ option.value }}</div>
				</div>
				<div v-if="!option.value" class="single" :class="{ text: option.type == 'text' }" v-html="option.label"></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'select-popup-view',
		props: ['options']
	}
</script>

<style lang="scss" scoped>
	.select-popup-view {
		& > .options {
			display: grid;
			row-gap: 1px;
			background-color: rgb(236, 236, 236);

			& > .option {
				background-color: white;

				& > .double {
					display: grid;
					grid-template-columns: 1fr 1fr;
					padding: 0 20px 0 20px;

					& > .value, & > .label {
						line-height: 48px;
					}

					& > .value {
						text-align: right;
						white-space: nowrap;
					}
				}

				& > .single {
					padding: 0 20px 0 20px;
					line-height: 48px;
					text-align: center;

					&.text {
						text-align: left;
						line-height: 20px;
						padding: 20px 20px 20px 20px;
					}
				}
			}
		}
	}
</style>